<template lang="pug">
  div
    active-item
      .dropdown(:class="{active: active}" slot-scope="{ setActive, active }" v-click-outside="() => setActive(false)")
        .dropdown__btn(@click.prevent="setActive(!active)")
          span(class="align-middle leading-10") {{ label }}
          mark(class="inline-flex items-center justify-center md:hidden ml-2")
            | 1
        fade-transition
          .dropdown__menu(class="px-16 pt-10 pb-12 md:min-w-350p" v-show="active")
              div(class="mb-8")
                | Quelle est la surface souhaitée ?
              .pb-10
                vue-range-slider(
                  :min="0"
                  :max="maxSurface"
                  tooltip="always"
                  :tooltip-formatter="formattedSurface"
                  v-model="surface"
                  tooltip-placement="bottom"
                  :interval="5"
                )
</template>

<script>
import VueRangeSlider from 'vue-slider-component'
import { debounce } from 'lodash'

export default {
  components: { VueRangeSlider },
  props: {
    initialSurfaceMin: {
      type: [Number, String],
      default: null
    },
    initialSurfaceMax: {
      type: [Number, String],
      default: null
    }
  },

  data () {
    return {
      maxSurface: null,
      surface: [0, null],
      label: 'Surface'
    }
  },

  watch: {
    surface: debounce(function () {
      if (this.surface[0] === 0) {
        this.$store.commit('deleteParams', 'by_min_surface')
      } else {
        this.$store.commit('updateParams', { key: 'by_min_surface', value: this.surface[0] })
      }

      if (this.surface[1] === this.maxSurface) {
        this.$store.commit('deleteParams', 'by_max_surface')
      } else {
        this.$store.commit('updateParams', { key: 'by_max_surface', value: this.surface[1] })
      }

      this.$store.dispatch('searchAccommodations')
        .then(({ surfaceLabel }) => {
          this.label = surfaceLabel
        })
    }, 100)
  },

  mounted () {
    this.maxSurface = Math.ceil(this.$store.getters.getMaxSurface / 10) * 10
    this.surface = [0, this.maxSurface]

    if (this.initialSurfaceMin) {
      this.surface = [+this.initialSurfaceMin, this.surface[1]]
    }

    if (this.initialSurfaceMax) {
      this.surface = [this.surface[0], +this.initialSurfaceMax]
    }

    this.$nextTick(() => {
      this.$store.commit('updateReady', 'surfaceRange')
    })
  },

  methods: {
    formattedSurface (value) { return `${value} m2` }
  }
}
</script>
